var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2931 23.3681V12.5858L22.1009 7.09095C22.1424 7.26374 22.1631 7.47109 22.1631 7.71301V16.1315C22.1631 16.8641 22.0352 17.4205 21.7795 17.8007C21.5307 18.1739 21.1436 18.5057 20.6183 18.796L12.656 23.2229C12.6007 23.2575 12.5419 23.2852 12.4797 23.3059C12.4175 23.3335 12.3553 23.3543 12.2931 23.3681ZM10.7069 23.3681C10.6447 23.3543 10.5825 23.3335 10.5203 23.3059C10.465 23.2852 10.4097 23.2575 10.3544 23.2229L2.38169 18.796C1.86331 18.5057 1.47625 18.1739 1.22052 17.8007C0.964781 17.4205 0.836914 16.8641 0.836914 16.1315V7.71301C0.836914 7.47109 0.857649 7.26374 0.89912 7.09095L10.7069 12.5858V23.3681ZM11.5052 11.1551L1.60412 5.67059C1.77691 5.51162 1.99463 5.35956 2.25728 5.21441L5.94815 3.16162L15.8907 8.71866L11.5052 11.1551ZM17.5806 7.79595L7.5966 2.24927L9.49387 1.19178C10.1574 0.818544 10.8278 0.631927 11.5052 0.631927C12.1825 0.631927 12.853 0.818544 13.5165 1.19178L20.7531 5.21441C21.0088 5.35956 21.2231 5.51162 21.3959 5.67059L17.5806 7.79595Z",
    fill: "#100E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPack);
export default __webpack_public_path__ + "static/media/pack.28c7d3a14b71883f22ae036ff0a5fa38.svg";
export { ForwardRef as ReactComponent };